import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { MemberActivity } from '../../shared/model/member-activity.model';
import { ObservationService } from '../../../shared/observation/observation.service';
import { Subscription } from 'rxjs';
import { NotificationService, PagedResult, PagedResultGeneric, TranslationService, UtilService } from 'src/app/shared';
import { ConfirmationService } from 'primeng/api';
import { UserService } from '../../../users/shared/user.service';

@Component({
  selector: 'wl-profile-view-member-activity',
  templateUrl: 'member-activity.component.html',
  styleUrls: ['member-activity.component.css'],
    standalone: false
})
export class ProfileViewMemberActivityComponent implements OnInit, OnDestroy, OnChanges {
  private _profileService: ProfileService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;
  private _id: number;

  @Input() public profileId: number;

  public memberActivity: Array<MemberActivity>;
  public showEdit = false;
  public editableMemberActivity: MemberActivity;
  public isSaving = false;
  public isReadOnly = true;
  public pagedMemberActivities: PagedResultGeneric<MemberActivity>;
  public showPaging = false;

  public constructor(
    profileService: ProfileService,
    observationService: ObservationService,
    private _confirmationService: ConfirmationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _userService: UserService
  ) {
    this._profileService = profileService;
    this._observationService = observationService;
    this.memberActivity = new Array<MemberActivity>();
    this.pagedMemberActivities = new PagedResult();
    this.editableMemberActivity = new MemberActivity();
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    let memberActivityPermission: any = this._userService
      .getCurrentUserSecurityElementAccessLevel('ProfileMember_Activity_Tab')
      .then((accessLevel: number) => {
        if (accessLevel == 2) this.isReadOnly = false;
      });
  }

  ngOnChanges() {
    this.loadData(1);
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadData(1, true);
    }
  }

  private loadData(page: number, forceRefresh?: boolean) {
    let result = {} as PagedResultGeneric<MemberActivity>;

    result.PageSize = 10;
    result.CurrentPageNumber = page;
    this._profileService.getProfileMemberActivity(this.profileId, forceRefresh).then((data: Array<MemberActivity>) => {
      this.memberActivity = data;

      let startIndex = (result.CurrentPageNumber - 1) * 10;
      let endIndex = startIndex + 10;

      result.TotalPages = ((this.memberActivity.length / 10) | 0) + 1;
      result.Result = data.slice(startIndex, endIndex);

      this.showPaging = result.TotalPages > 1;
      this.pagedMemberActivities = result;
    });
  }

  public openCreateDialog() {
    this.editableMemberActivity = new MemberActivity();
    this.editableMemberActivity.ProfileId = this.profileId;
    this.showEdit = true;
  }

  public openEditDialog(activity: MemberActivity) {
    this.editableMemberActivity = Object.assign({}, activity);
    this.showEdit = true;
  }

  public async createMemberActivity() {
    this.isSaving = true;
    if (this.editableMemberActivity.ActivityId > 0) {
      await this._profileService.updateMemberActivity(this.editableMemberActivity);
    } else {
      await this._profileService.createMemberActivity(this.editableMemberActivity);
    }

    this.loadData(1, true);
    this.showEdit = false;
    this.isSaving = false;
  }

  public cancelEdit() {
    this.showEdit = false;
  }

  public deleteMemberActivity(memberActivity: MemberActivity) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('profiles.view.member-activity.confirm-delete-message'),
      key: 'deleteMemberActivityCD',
      accept: () => {
        this._profileService
          .deleteMemberActivity(memberActivity.ActivityId)
          .then(() => {
            this._notificationService.translatePersistentSuccess('profiles.view.member-activity.delete-success-message');
            this.loadData(1, true);
            this._confirmationService.close();
          })
          .catch((error) => {
            this._notificationService.httpError(error);
          });
      },
      reject: () => {
        this._confirmationService.close();
      }
    });
  }

  public onPagingEvent(page: number) {
    this.pagedMemberActivities.CurrentPageNumber = page;
    let startIndex = (this.pagedMemberActivities.CurrentPageNumber - 1) * 10;
    let endIndex = startIndex + 10;
    this.pagedMemberActivities.Result = this.memberActivity.slice(startIndex, endIndex);
  }

  public onAccept($event) {
    alert($event);
    this._confirmationService.onAccept();
  }

  public onReject($event) {
    this._confirmationService.close();
  }
}
